export default __webpack_public_path__ + "static/media/lens_icon.79a711c7.png";